export default __webpack_public_path__ + "static/media/icons8-globe.bd578b97.gif";